<script setup lang="ts">
import AuditTable from "@/components/AuditTable.vue";
import ShadowBox from "@/components/ShadowBox.vue";
import { Hotel } from "@/internal/modules/providers/interfaces/Hotel";
import useHotelLog from "../composables/useHotelLog";

interface Props {
  hotel: Hotel;
}

const props = defineProps<Props>();

const { data, isLoading, page, setPage, refetch } = useHotelLog({
  immediate: true,
  params: {
    id: props.hotel.id,
  },
});
</script>

<template>
  <AuditTable
    :logs="data?.data!"
    :page="page"
    :pagination="data!"
    @search="refetch"
    @set-page="setPage"
    class-table="flex flex-col"
  />

  <LoadingModal :when="isLoading" />
</template>
